import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';

// DOM이 완전히 로드된 후 실행
document.addEventListener('DOMContentLoaded', () => {
  const rootElement = document.getElementById('root');
  if (rootElement) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(<App />);
  }
});
